import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { ISalesOrderLineD365 } from "../../../declarations/SalesOrderLineD365";
import { IReadVerbPayload } from "../../../declarations/IReadVerbPayload";

const getSalesOrderLinesD365 = async (
    payload: IReadVerbPayload,
): Promise<ISalesOrderLineD365[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<ISalesOrderLineD365[]>(
        `/SalesOrderLine/GetSalesOrderLinesD365`,
        payload,
    );
    return response.data;
};

export const useGetSalesOrderLinesD365 = (payload: IReadVerbPayload) => {
    const dataAreaId = payload.keys.dataAreaId as string;
    const orderNumber = payload.keys.salesOrderNumber as string;

    return useQuery<ISalesOrderLineD365[]>({
        queryKey: [
            "GetSalesOrderLinesD365",
            {
                dataAreaId: dataAreaId ?? null,
                orderNumber: orderNumber ?? null,
            },
        ],
        queryFn: () => {
            if (!dataAreaId?.trim() || !orderNumber?.trim()) {
                throw new Error("Invalid params for GetSalesOrderLinesD365");
            }
            return getSalesOrderLinesD365(payload);
        },
        enabled: Boolean(dataAreaId?.trim()) && Boolean(orderNumber?.trim()),
        refetchOnWindowFocus: false,
        retry: false,
    });
};
